const parameterInputFieldTranslations = {
  coordinateSystem: 'Projection system',
  coordinateSystemHelp:
    '(Required only if .zip file does not contain projection file)'
}

export default parameterInputFieldTranslations
